import React, { useState } from 'react';
import { Card } from '../ui/Card';
import { usePersonalNotes, Note } from '../../hooks/usePersonalNotes';
import { Pin, Plus, Trash2, Edit2, X, Check } from 'lucide-react';
const COLORS = ['bg-indigo-950/40 border-indigo-900/40', 'bg-emerald-950/40 border-emerald-900/40', 'bg-amber-950/40 border-amber-900/40', 'bg-rose-950/40 border-rose-900/40', 'bg-slate-800/40 border-slate-700/40'];
export function PersonalNotesWidget() {
  const {
    notes,
    addNote,
    updateNote,
    removeNote,
    togglePin
  } = usePersonalNotes();
  const [editingId, setEditingId] = useState<string | null>(null);
  const [editTitle, setEditTitle] = useState('');
  const [editContent, setEditContent] = useState('');
  const [editColor, setEditColor] = useState(COLORS[0]);
  const sortedNotes = [...notes].sort((a, b) => {
    if (a.pinned && !b.pinned) return -1;
    if (!a.pinned && b.pinned) return 1;
    return new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime();
  });
  const handleEdit = (note: Note) => {
    setEditingId(note.id);
    setEditTitle(note.title);
    setEditContent(note.content);
    setEditColor(note.color);
  };
  const handleSave = () => {
    if (editingId) {
      updateNote(editingId, {
        title: editTitle,
        content: editContent,
        color: editColor
      });
    } else {
      addNote({
        title: editTitle,
        content: editContent,
        color: editColor,
        pinned: false
      });
    }
    setEditingId(null);
  };
  const handleCancel = () => {
    setEditingId(null);
  };
  const handleAddNew = () => {
    setEditingId('new');
    setEditTitle('');
    setEditContent('');
    setEditColor(COLORS[0]);
  };
  return <Card className="h-full bg-slate-900 border-slate-800 flex flex-col max-h-[400px]" data-id="element-3137">
      <div className="p-4 border-b border-slate-800 flex items-center justify-between shrink-0" data-id="element-3138">
        <h3 className="text-sm font-semibold text-slate-100 flex items-center gap-2" data-id="element-3139">
          <span className="w-2 h-2 rounded-full bg-amber-500" data-id="element-3140"></span>
          Notas Personales
        </h3>
        <button onClick={handleAddNew} disabled={editingId !== null} className="p-1 text-slate-400 hover:text-indigo-400 disabled:opacity-50 transition-colors" data-id="element-3141">
          <Plus size={16} data-id="element-3142" />
        </button>
      </div>

      <div className="flex-1 overflow-y-auto p-4 custom-scrollbar" data-id="element-3143">
        {editingId === 'new' && <div className={`p-3 rounded-xl border mb-4 ${editColor}`} data-id="element-3144">
            <input type="text" value={editTitle} onChange={e => setEditTitle(e.target.value)} placeholder="Título de la nota" className="w-full bg-transparent text-sm font-bold text-slate-200 placeholder:text-slate-500 focus:outline-none mb-2" autoFocus data-id="element-3145" />

            <textarea value={editContent} onChange={e => setEditContent(e.target.value)} placeholder="Escribe tu nota aquí..." className="w-full bg-transparent text-xs text-slate-300 placeholder:text-slate-500 focus:outline-none resize-none min-h-[80px]" data-id="element-3146" />

            <div className="flex items-center justify-between mt-2 pt-2 border-t border-slate-700/50" data-id="element-3147">
              <div className="flex gap-1" data-id="element-3148">
                {COLORS.map(c => <button key={c} onClick={() => setEditColor(c)} className={`w-4 h-4 rounded-full ${c.split(' ')[0]} border ${editColor === c ? 'border-slate-300' : 'border-transparent'}`} data-id="element-3149" />)}
              </div>
              <div className="flex gap-2" data-id="element-3150">
                <button onClick={handleCancel} className="text-slate-400 hover:text-slate-200" data-id="element-3151">
                  <X size={14} data-id="element-3152" />
                </button>
                <button onClick={handleSave} className="text-emerald-400 hover:text-emerald-300" data-id="element-3153">
                  <Check size={14} data-id="element-3154" />
                </button>
              </div>
            </div>
          </div>}

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3" data-id="element-3155">
          {sortedNotes.map(note => <div key={note.id} data-id="element-3156">
              {editingId === note.id ? <div className={`p-3 rounded-xl border h-full flex flex-col ${editColor}`} data-id="element-3157">
                  <input type="text" value={editTitle} onChange={e => setEditTitle(e.target.value)} className="w-full bg-transparent text-sm font-bold text-slate-200 focus:outline-none mb-2" data-id="element-3158" />

                  <textarea value={editContent} onChange={e => setEditContent(e.target.value)} className="w-full flex-1 bg-transparent text-xs text-slate-300 focus:outline-none resize-none min-h-[80px]" data-id="element-3159" />

                  <div className="flex items-center justify-between mt-2 pt-2 border-t border-slate-700/50" data-id="element-3160">
                    <div className="flex gap-1" data-id="element-3161">
                      {COLORS.map(c => <button key={c} onClick={() => setEditColor(c)} className={`w-4 h-4 rounded-full ${c.split(' ')[0]} border ${editColor === c ? 'border-slate-300' : 'border-transparent'}`} data-id="element-3162" />)}
                    </div>
                    <div className="flex gap-2" data-id="element-3163">
                      <button onClick={handleCancel} className="text-slate-400 hover:text-slate-200" data-id="element-3164">
                        <X size={14} data-id="element-3165" />
                      </button>
                      <button onClick={handleSave} className="text-emerald-400 hover:text-emerald-300" data-id="element-3166">
                        <Check size={14} data-id="element-3167" />
                      </button>
                    </div>
                  </div>
                </div> : <div className={`group relative p-3 rounded-xl border h-full flex flex-col transition-all hover:shadow-md ${note.color}`} data-id="element-3168">
                  <div className="flex items-start justify-between mb-1" data-id="element-3169">
                    <h4 className="text-sm font-bold text-slate-200 line-clamp-1 pr-6" data-id="element-3170">
                      {note.title}
                    </h4>
                    <button onClick={() => togglePin(note.id)} className={`absolute top-3 right-3 transition-colors ${note.pinned ? 'text-amber-400' : 'text-slate-500 opacity-0 group-hover:opacity-100 hover:text-slate-300'}`} data-id="element-3171">
                      <Pin size={12} className={note.pinned ? 'fill-amber-400' : ''} data-id="element-3172" />
                    </button>
                  </div>
                  <p className="text-xs text-slate-400 whitespace-pre-wrap line-clamp-4 flex-1" data-id="element-3173">
                    {note.content}
                  </p>
                  <div className="flex items-center justify-between mt-3 pt-2 border-t border-slate-700/30" data-id="element-3174">
                    <span className="text-[9px] text-slate-500" data-id="element-3175">
                      {new Date(note.updatedAt).toLocaleDateString()}
                    </span>
                    <div className="flex gap-2 opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-3176">
                      <button onClick={() => handleEdit(note)} className="text-slate-400 hover:text-indigo-400" data-id="element-3177">
                        <Edit2 size={12} data-id="element-3178" />
                      </button>
                      <button onClick={() => removeNote(note.id)} className="text-slate-400 hover:text-red-400" data-id="element-3179">
                        <Trash2 size={12} data-id="element-3180" />
                      </button>
                    </div>
                  </div>
                </div>}
            </div>)}
        </div>

        {notes.length === 0 && editingId !== 'new' && <div className="text-center py-12 text-slate-500 text-xs" data-id="element-3181">
            No tenés notas. Hacé click en el + para crear una.
          </div>}
      </div>
    </Card>;
}